import { ContentFieldType } from "../../../types/cms/contentField.type";
import { getValidTags } from "../../tags";
import type { TagItem } from "../../tags";
import { SINGLE_TOKEN_REGEX } from "../internal/constants";
import { resolvePath } from "../internal/resolvePath";
import type { InterpolateParams } from "../types";

export function extractTags({ structure, template }: InterpolateParams): TagItem[] {
  const match = template.match(SINGLE_TOKEN_REGEX);
  if (!match) return [];

  const [, path, type] = match;
  if (type !== ContentFieldType.TAGS) return [];

  return getValidTags(resolvePath(structure, path));
}
